const forbiddenKeys = ['__proto__', 'prototype', 'constructor']

// Les chemins décrivent les alias de la requête, jamais des expressions exécutables.
export function enrichmentIdentifier(row, path) {
  return String(path || 'id').trim().split(/[.\s]+/).reduce((value, key) =>
    value && !forbiddenKeys.includes(key) ? value[key] : undefined, row)
}

export function validEnrichmentTarget(target) {
  return typeof target === 'string' && /^[A-Za-z_][A-Za-z0-9_]*$/.test(target) && !forbiddenKeys.includes(target)
}

// Une description alimente les suggestions sans charger les données métier.
export function enrichmentVisualFields(configs, schemas) {
  const fields = []
  ;(configs || []).filter(config => config.enabled !== false && validEnrichmentTarget(config.target)).forEach(config => {
    const schema = schemas[config.provider] || {}
    const descriptor = schema.enrichissement || schema
    const walk = (items, prefix) => {
      (items || []).forEach(field => {
        if (!field || !field.key) return
        const value = `${prefix} ${field.key}`
        fields.push({ text: `${field.label || field.key} (${value})`, value })
        if (field.type !== 'array' && field.type !== 'collection' && Array.isArray(field.fields)) walk(field.fields, value)
      })
    }
    walk(descriptor.fields, config.target)
  })
  return fields
}

// Un cycle est invalidé au changement de page, de filtre ou au démontage.
export class ModuleEnrichmentRunner {
  constructor() { this.generation = 0 }
  invalidate() { this.generation++ }

  async run({ rows, configs, api, moduleId, token, params, querys, set, onError, onLoading }) {
    const generation = ++this.generation
    const active = () => generation === this.generation
    const tasks = (Array.isArray(configs) ? configs : []).map((config, index) => ({ config, index }))
      .filter(({ config }) => config && config.enabled !== false && config.provider && validEnrichmentTarget(config.target))
    if (!tasks.length || !Array.isArray(rows) || !rows.length) { if (onLoading) onLoading(false); return }
    if (onLoading) onLoading(true)
    try {
      for (const { config, index } of tasks) {
        if (!active()) return
        const pairs = rows.map(row => ({ row, id: enrichmentIdentifier(row, config.identifierField) }))
          .filter(({ row, id }) => (typeof id === 'number' || typeof id === 'string') && String(id).trim() !== '' && !Object.prototype.hasOwnProperty.call(row, config.target))
        const ids = [...new Set(pairs.map(pair => String(pair.id)))]
        for (let offset = 0; offset < ids.length; offset += 500) {
          if (!active()) return
          const response = await api({ type: 'post', url: 'displaymodule', params: {
            id: moduleId, operation: 'moduleEnrichmentExecute', enrichmentIndex: index,
            ids: ids.slice(offset, offset + 500), enrichmentToken: token, params: params || {}, querys: querys || {},
          } })
          if (!active()) return
          const data = (response && response.data) || {}
          if (data.success === false) { if (onError) onError(data.message || 'L’enrichissement métier a échoué.'); break }
          const results = data.results || {}
          pairs.forEach(({ row, id }) => {
            if (Object.prototype.hasOwnProperty.call(results, String(id)) && !Object.prototype.hasOwnProperty.call(row, config.target)) {
              set(row, config.target, results[String(id)])
            }
          })
        }
      }
    } catch (error) {
      if (active() && onError) onError('L’enrichissement métier a échoué.')
    } finally {
      if (active() && onLoading) onLoading(false)
    }
  }
}
